module.exports = __webpack_public_path__ + "img/journal-icon.2c369121.svg";